module.exports = {
  "landing.company.directory.label": "Compañías de seguros de autos",
  "product.featured.partner.label": "PATROCINADO"
}
